export const NBU_API = 'https://bank.gov.ua/NBUStatService/v1/statdirectory/exchange?json';

export const PRIVAT_API = 'https://api.privatbank.ua/p24api/pubinfo?exchange&coursid=5';